// src/pages/Home.jsx
import React from 'react';
import Hero from '../components/Hero';
import Intro from '../components/Intro';
import DocumentarySection from '../components/DocumentarySection';
import Video from '../components/Video';
import Stats from '../components/Stats';
import Life from '../components/Life';
import Footer from '../components/Footer';

function Home() {
  return (
    <>
      <Hero />
      <Intro />
      <DocumentarySection />
      {/* <Video /> */}
      <Stats />
      <Life />
      <Footer />
    </>
  );
}

export default Home;
